var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"flex-1 w-100",staticStyle:{"min-height":"2000px","min-width":"900px"},attrs:{"id":"iframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }